import React from 'react'
import Blogs from './components/Blogs'

const App = () => {
  return (
    <div>
      <Blogs />
    </div>
  )
}

export default App
